module.exports = __webpack_public_path__ + "static/media/mobile-steps-intro.acf67404.png";